import {
  RfpVoluntaryLifeAmountNotToExceedTypeEnum,
  RfpVoluntaryLifeSpouseChildBenefitTypeEnum,
} from "@platform/openapi-types";

export const spouseChildBenefitDescriptionLabels = {
  [RfpVoluntaryLifeSpouseChildBenefitTypeEnum.percentageOfEmployeeElection]:
    "Percentage of EE Election",
};

export const spouseAmountNotToExceedLabels = {
  [RfpVoluntaryLifeAmountNotToExceedTypeEnum.percentageOfEmployeeElection]:
    "Percentage of EE Election",
};
